import React, { useState, useEffect } from "react";
import { setStartDate, setEndDate, runQueryCVS } from "../../redux/action";
import { RootState } from "../../redux/reducer";
import { connect, ConnectedProps } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";
import _ from "lodash";
import {  CVSProductData } from "./events.config";
import CommonTable from "../../components/Table/CommonTable"
import axios from "axios";
import {downloadCSV} from '../kayJwellers/helper'
import useClasses from "../../common/UseClasses";
import { Button, Grid, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from "dayjs";

type PropsFromRedux = ConnectedProps<typeof connector>;
type CVSMainProps = PropsFromRedux & {};

  const useStyles = () => ({
    container: {
        height: 440,
    },

    csvButton: {
        backgroundColor: "rgba(107,147,57,1)",
        height: 30,
        width : 80,
        paddingLeft: 10,
        paddingRight: 10,
        borderRadius: 5,
        color: "white",
        textDecorationLine: "none",
        marginBottom: 5,
        fontSize: 12,
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
});
const CVSMain: React.FC<CVSMainProps> = ({
  startDateObj,
  endDateObj,
  setStartDate,
  setEndDate,
  runQueryCVS,
  ...rest
}) => {


    const classes = useClasses(useStyles);

    const [eventsData, setEventsData] = useState<any>({})
    const [totalCount, setTotalCount] = useState<{[key:string]:number}>({})


    const handleFromDateChange = (date: any) => {
      setStartDate(date.$d)
    };
    const handleToDateChange = (date: any) => {
      setEndDate(date.$d);
    };

    const getProductData = async () => {

        let categorydata: any = {}
        let count:{[key:string]:number} = {};
        const startDate = moment(startDateObj).format('YYYYMMDD');
        const endDate = moment(endDateObj).format('YYYYMMDD');

        for(const product of CVSProductData) { /* loop over each table configuration defined into events.config */
            count[product.label] = 0;
            var isValueSplit = false
            let tableData: any = {
                tableHeader: [],
                tableRow: []
            };
            let query = `${product.query} AND event_date >= '${startDate}' AND  event_date <= '${endDate}' ${product.appendquery}`; /* dynamically loads query from configuration file and forms query */

            const result: any = await runQueryCVS({ query }, false); /*function call to execute query and retrieve data */
            let arr : any = []
            // eslint-disable-next-line no-loop-func
            result.forEach(async (resultdata: any, resultindex : number) => { /* loop over each object from response received from query */
                const obj: any = {}
                // let product_sku = resultdata['product_sku'];
                product.headers.forEach((keyelement: any) => { /* map rows according to configuration defined in headers of configuration file */
                    const headerkey = keyelement.key;
                    obj[headerkey] = resultdata[headerkey];
                    if (headerkey === "product_id" && resultdata[headerkey] == null) {
                      obj[headerkey] = 'Product id is missing'
                    }
                    if (headerkey === 'product') {
                      let productDataArray = resultdata[headerkey].split(/[_]+/);
                      var productId = productDataArray.pop();
                      obj[headerkey] = productDataArray.join("_")
                      obj["splitted_product_id"] = productId
                      isValueSplit = true
                    }
                    if(headerkey === "value")
                        count[product.label] += resultdata[headerkey]; /* add each event count into total count of each table */   
                })

                tableData.tableRow.push(obj); /* add row into  data array */
                arr.push(obj)
            })

            if (isValueSplit) {
            product.headers = [
              { label: "Product", key: "product" },
              { label: "Product ID", key: "splitted_product_id" },
              { label: "Event Name", key: "event_name" },
              { label: "Event Count", key: "value" },
            ]
          }
            tableData.tableHeader.push(...product.headers)
            categorydata[product.label] = tableData; /* map table dynamically */

        }
       // console.log(categorydata)

        setEventsData(categorydata) /* update state variable with data for each table */
        setTotalCount(count) /* update total count for each table of state variable */
    }

  return (
      <div>
        <div
        style={{
          display: "flex",
          flex: 1,
          padding: 16,
          alignItems: "center",
          marginBottom: 20,
          marginTop:30
        }}
      >
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DatePicker
label="From Date"
format="MM/DD/YYYY"
value={dayjs(startDateObj)}
sx={{marginRight:'10px'}}
onChange={handleFromDateChange}
/>
<DatePicker
label="To Date"
format="MM/DD/YYYY"
value={dayjs(endDateObj)}
sx={{marginRight:'10px'}}
onChange={handleToDateChange}
/>
    </LocalizationProvider>

        {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            margin="normal"
            id="date-picker-dialog"
            label="From Date"
            format="MM/dd/yyyy"
            value={startDateObj}
            onChange={handleFromDateChange}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
            autoOk={true}
          />

          <KeyboardDatePicker
            style={{ marginLeft: 16 }}
            margin="normal"
            id="date-picker-dialog"
            label="To Date"
            format="MM/dd/yyyy"
            value={endDateObj}
            onChange={handleToDateChange}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
            autoOk={true}
          />
        </MuiPickersUtilsProvider> */}

        <Button
          variant="contained"
          color="secondary"
          style={{
            height: 40,
            marginLeft: 20,
            width: 150,
          }}
          onClick={() => getProductData()}
        >
          Apply
        </Button>
      </div>
      <Grid container spacing={4}  padding={2}>
      {

        eventsData ?(Object.keys(eventsData)?.map((row: string, i: number) => {

        let tabledata = eventsData[row];
       // console.log(tabledata)
           return (
                <Grid item md={12} xs={6} lg={6} key={i}>

                    <div style={{display: "flex"}}>
                        <div style={{ flex: 1 }}>
                        <Typography style={{ fontSize: 14, fontWeight: 800 }} color="primary">
                            {`${row}`} <br/> {`(Total Count : ${totalCount[row]}) `}
                        </Typography>
                        </div>
                        <div style={{ justifyContent:"flex-end"}}>

                        <Button
                          variant="contained"
                          color="primary"
                            sx={{
                            height:40,
                            width:200,
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom:3
                            }}
                          onClick={() => downloadCSV(tabledata.tableRow, row, tabledata.tableHeader)}
                          > Download CSV</Button>
                        </div>
                        </div>
                        {
                        eventsData[row] ? (
                            <CommonTable tableData={eventsData[row]} />
                        ) : null}
                </Grid>
            )
            }
        )) : null
      }

      </Grid>
      </div>
  )
}


const mapState = (state: RootState) => ({
  isUserLoggedIn: state.user.isUserLoggedIn,
  startDateObj: state.report.startDate,
  endDateObj: state.report.endDate,
});

const mapDispatch = {};

const connector = connect(mapState, {
  setStartDate,
  setEndDate,
  runQueryCVS
});

export default connector(CVSMain);